import ForgotPasswordForm from '@/components/forms/ForgotPasswordForm';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { getRedirectRoute } from '@/utils/redirect';
import { getPendingTenantSelectionFlag, clearPendingTenantSelectionFlag } from '@/utils/loginFlow';
import AuthPageShell from '@/components/auth/AuthPageShell';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/forgot-password')({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    if (!context?.auth) clearPendingTenantSelectionFlag();
    if (context?.auth && !getPendingTenantSelectionFlag()) {
      throw redirect({ to: getRedirectRoute(context.auth) });
    }
  }
});

function RouteComponent() {
  const { t } = useTranslation(['auth', 'common']);

  return (
    <AuthPageShell
      title={t('auth:forgotPassword.title')}
      subtitle={t('auth:forgotPassword.subtitle')}
      decoration="default"
    >
      <ForgotPasswordForm />
    </AuthPageShell>
  );
}
